export const Api = {
	baseUrl: import.meta.env.VITE_API_URL ?? '',
	catastro: '/api/catastro',
	auth: {
		login: '/api/auth/login',
		loginAs: '/api/data/users/issue',
		recovery: '/api/auth/password-recovery',
		reset: '/api/auth/password-reset',
		renew: '',
	},
	hal: {
		base: '/api/data',
	},
	schemas: {
		base: '/api/schemas',
		managedEntities: '/api/schemas/entities',
	},
	alerts: {
		preview: '/api/alerts/compute',
	},
	observations: {
		latest: '/api/data/virtual-stations/latest',
		series: '/api/data/stations/series',
		seriesExcel: '/api/data/stations/series/excel',
		virtualSeries: '/api/data/virtual-stations/series',
	},
} as const;
